import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import * as React from "react";
import "./scss/index.scss";

var MenuDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(MenuDropdown, _React$Component);

  function MenuDropdown(props) {
    var _this;

    _classCallCheck(this, MenuDropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuDropdown).call(this, props));
    _this.state = {
      active: false
    };
    return _this;
  }

  _createClass(MenuDropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", {
        "data-test": "userButton",
        className: "menu-dropdown",
        onMouseOver: function onMouseOver() {
          return _this2.setState({
            active: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            active: false
          });
        }
      }, this.props.head, React.createElement("div", null, this.props.content));
    }
  }]);

  return MenuDropdown;
}(React.Component);

MenuDropdown.defaultProps = {
  suffixClass: ""
};
export default MenuDropdown;